import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;


@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  selectedFile:any;
  public userId:any='';
  public viewshow:boolean = true;
  public viewshow1:boolean = false;
  public termCheck : boolean = false ;
  public typeCheck : boolean = false ;
  public userTypeList:any =[];
  public termData:any= window.location.origin+'/terms-conditions';
  public privacyData:any= window.location.origin+'/privacy-policy';
  public usertYpes:any=3;
  public currentUrl:any=this.router.url;
  public refCode:any='';
  public Email:any='';
  public usedEmail:boolean=false;
  public usedName:boolean=false;

  SignupData = new FormGroup({
    firstname:new FormControl('',Validators.compose([
      Validators.required ])),
    handlename:new FormControl('',Validators.compose([
      Validators.required ,Validators.minLength(2),])),
    lastname:new FormControl('',Validators.compose([
      Validators.required ])),    
    email:new FormControl('',Validators.compose([
      Validators.required, Validators.email  ])),
    password:new FormControl('',Validators.compose([
      Validators.required,Validators.minLength(8),
      Validators.maxLength(30) ,
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}')])),
    confirm_password:new FormControl('',Validators.compose([
      Validators.required, Validators.minLength(8),
      Validators.maxLength(30) ,
      Validators.pattern('^(?=.*[A-Z])(?=.*\\d)[A-Za-z\\d-_}/\{|:;?!@#$%^&*+=~<>()`]{8,30}')])),
    refCode:new FormControl(''),
    userType:new FormControl('',Validators.compose([
      Validators.required ])),         
  })
  
  get f() { return this.SignupData.controls; } 
  
  constructor(public router: Router, private service: GlobalService) { 
    this.getRoles();
    // this.getstatic();
   }

  ngOnInit(): void {
  }

  Onsubmit(){
    this.submitted = true;  
    let userdetail = this.SignupData; 
    if(this.usertYpes==2){
      if(this.typeCheck == false){
      this.service.dangerAlert('Please accept the authorisation');
      return;
      }
    } 
     if(this.termCheck == false){
      this.service.dangerAlert('Please accept the Terms and Conditions');
    } else if (userdetail.value.confirm_password != userdetail.value.password) {
      this.service.dangerAlert('Password not match');        
      return;
      } else {
        if(userdetail.valid){
          this.loading = true; 
          var ss :any=0;
          if(this.typeCheck == true){
            ss=1;
          }
          var url="/sign-up";
          var detail={
            "firstName": userdetail.value.firstname,
            "lastName": userdetail.value.lastname, 
            "email": (userdetail.value.email)?.toLowerCase(),
            "password": userdetail.value.password,
            "role": userdetail.value.userType,
            "referral_code": userdetail.value.refCode,
            "userHandler": (userdetail.value.handlename)?.toLowerCase(),
            "authorized_person":ss
          }
          this.service.PostApis(detail,url).subscribe(((response:any)=>{
            if(response.success ==1){ 
              // localStorage.setItem('grw_loginData',JSON.stringify({"email": userdetail.value.email,"password": userdetail.value.password})); 
                this.viewshow = false;
                this.viewshow1 = true;
              this.loading = false;
            } else {
              this.loading = false;
              this.service.dangerAlert(response.message);
            }
          }), (error:any) => {
          });
        } else{
        }
      }
  }

  showHide(str: any) {
    var input = $($(str).attr("toggle"));
    if (input.attr("type") == "password") {
      input.attr("type", "text");
      $(str).removeClass("fa fa-eye-slash");
      $(str).addClass("far fa-eye ");
    } else {
      input.attr("type", "password");
      $(str).removeClass("far fa-eye ");
      $(str).addClass("fa fa-eye-slash");
    }
  }

  checkEmailUnique(event: any) { 
    this.loading=true;
    const email = event.target.value;
    if (email.length > 0) {
      this.service.PostApis({ email: email }, "/check-unique-email").subscribe(
        (response: any) => {
          if (response.success !=1) {
            // event.target.value = "";
            this.usedEmail=true;
            this.service.dangerAlert(response.message);  
          } else{
            this.usedEmail= false;
          }
          this.loading=false;
        },
        (error) => {
        }
      );
      this.loading=false;
    } else{
      this.usedEmail= false;
      this.loading=false;

    }
  }

  checkhandlerUnique(event: any) {
    this.loading=true;
    const email = event.target.value;
    if (email.length > 0) {
      this.service.PostApis({ userHandler: email }, "/check-unique-user-handle").subscribe(
        (response: any) => {
          if (response.success !=1) {
            // event.target.value = "";  
            this.usedName=true;
            this.service.dangerAlert(response.message);        
          } else {
            this.usedName=false;
          }
          this.loading=false;
        },
        (error) => {
          this.loading=false;
        }
      );
      this.loading=false;
    } else{
      this.usedName=false;
      this.loading=false;
    }
  }

  getCheckType(event:any,type:any){
    if(type == 1){
      this.typeCheck = event.target.checked;
    } else {
      this.termCheck = event.target.checked;
    }
    
  }

  getRoles(){
    const url = "/get-roles"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        var self =this;
        response.data.filter((el:any)=>{
          if(el.role_id==3){
            self.SignupData.controls['userType'].setValue(el._id);
          }         
        })
        this.userTypeList = response.data;
    if(this.currentUrl.includes('?')){
      var s:any=this.currentUrl.split('?');
      this.currentUrl=s[0];
      var l:any=s[1].split('&');
      var m:any=l[1].split('=');
      var j:any=l[0].split('=');
      this.usertYpes=3;
      this.refCode =j[1];
      this.Email =m[1];
      
    }
    console.log(this.currentUrl);
      }
    }), (error) => { this.loading =false; });
  }

  getstatic(){
    this.service.GetApi("/privacy-policy").subscribe(((response:any)=>{
      if(response.success ==1) {
        this.privacyData = response.data;
      }
    }), (error) => { this.loading =false; });

    this.service.GetApi("/term-conditions").subscribe(((response:any)=>{
      if(response.success ==1) {
        this.termData = response.data;
      }
    }), (error) => { this.loading =false; });
  }

  setCheckval(event:any){
    var self =this;
    this.userTypeList.filter((el:any)=>{
      if(el._id == event.value){
        self.usertYpes= el.role_id;
      }
    })
  }


}
